import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo } from '../data/mock';

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openWhatsApp = (number) => {
    const message = encodeURIComponent(t.whatsapp.message);
    const url = `https://wa.me/${number}?text=${message}`;
    window.open(url, '_blank');
    setShowMenu(false);
  };

  return (
    <div className={`fixed bottom-8 right-8 z-50 transition-all duration-300 ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'
    }`}>
      {/* WhatsApp Menu */}
      {showMenu && (
        <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-2xl p-4 mb-2 min-w-[250px]">
          <div className="space-y-3">
            <p className="text-sm font-semibold text-slate-800 mb-3">
              {language === 'en' ? 'Choose WhatsApp Number' : 'Pilih Nomor WhatsApp'}
            </p>
            <button
              onClick={() => openWhatsApp(contactInfo.whatsapp)}
              className="w-full flex items-center space-x-3 p-3 rounded-lg bg-green-50 hover:bg-green-100 transition-colors"
            >
              <MessageCircle className="w-5 h-5 text-green-600" />
              <div className="text-left">
                <p className="text-sm font-semibold text-slate-800">{contactInfo.phone}</p>
                <p className="text-xs text-slate-500">
                  {language === 'en' ? 'Primary Contact' : 'Kontak Utama'}
                </p>
              </div>
            </button>
            <button
              onClick={() => openWhatsApp(contactInfo.whatsapp2)}
              className="w-full flex items-center space-x-3 p-3 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <MessageCircle className="w-5 h-5 text-blue-600" />
              <div className="text-left">
                <p className="text-sm font-semibold text-slate-800">{contactInfo.phone2}</p>
                <p className="text-xs text-slate-500">
                  {language === 'en' ? 'Alternative Contact' : 'Kontak Alternatif'}
                </p>
              </div>
            </button>
          </div>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-green-600 text-white shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center group relative"
      >
        {showMenu ? (
          <X className="w-8 h-8" />
        ) : (
          <>
            <MessageCircle className="w-8 h-8 group-hover:scale-110 transition-transform" />
            {/* Pulse Animation */}
            <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75" />
          </>
        )}
        
        {/* Tooltip */}
        {!showMenu && (
          <div className="absolute right-full mr-4 px-4 py-2 bg-slate-900 text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
            {t.contact.info.whatsapp}
          </div>
        )}
      </button>
    </div>
  );
};
